

import { GetIntermediaryExternalResponseDto, GetTaxpayerIntermediariesResponseDto, IntermediaryDetailsResponseDto } from '../Service/proxy';
import { getIntermediariesCurrent, getRepresentationsCurrent, intermediariesCurrentApplication, intermediariesCurrentContactDetails, IntermediaryActionTypes, LoadCurrentIntermediary, LOAD_INTERMEDIARIES_LIST, ADD_INTERMEDIARY, validationOTPcode, LOAD_TAXPAYER_INTERMEDIARIES,changeAppStatus } from './Types';

export interface IntermediaryState {
    intermediariesList?: GetIntermediaryExternalResponseDto;
    intermediaryDetails?: IntermediaryDetailsResponseDto;
    representedTaxpayers?: GetTaxpayerIntermediariesResponseDto;
    taxpayerIntermediaries?: GetTaxpayerIntermediariesResponseDto;
    IsRenew?: boolean;
}

const initialState: IntermediaryState = {};

export function IntermediaryReducer(
    state = initialState,
    action: IntermediaryActionTypes
) {
    switch (action.type) {

      
        case LOAD_INTERMEDIARIES_LIST:
            return {
                ...state,
                intermediariesList: { ...action.payload },
            };
            case changeAppStatus:
            return {
                ...state,
                IsRenew: action.payload.IsRenew,
            };
        case LOAD_TAXPAYER_INTERMEDIARIES:
            return {
                ...state,
                taxpayerIntermediaries: { ...action.payload },
            };
        case LoadCurrentIntermediary:
            return {
                ...state,
                intermediaryDetails: { ...action.payload },
            };
        case intermediariesCurrentApplication:
            return {
                ...state,
                ...action.payload,
            };
        case intermediariesCurrentContactDetails:
            return {
                ...state,
                ...action.payload,
            };
        case validationOTPcode:
            return {
                ...state,
                ...action.payload,
            };
        case getIntermediariesCurrent:
            return {
                ...state,
                DetailscurrentIntermediary: { ...action.payload },
            };
        case getRepresentationsCurrent:
            return {
                ...state,
                RepresentationsCurrent: { ...action.payload },
            };         
        case ADD_INTERMEDIARY:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
}